import { createSlice } from "@reduxjs/toolkit";
import { loginUserAPI } from "../../api/auth";

const data = {
  loading: false,
  error: "",
  message: null,
  data: null,
};

const loginUserSlice = createSlice({
  name: "login",
  initialState: data,
  reducers: {
    loginSlice(state) {
      state.loading = false;
    },
    loginSliceSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    loginSliceFailure(state, action) {        
      state.loading = false;
      state.data = action.payload;
    },
    loginresetSlice(state) {
      state.loading = false;
      state.error = "";
      state.message = null;
      state.data = null;
    },
  },
});

export const loginUserHandle = (data:any) =>async (dispatch:any)=>{
    try {
        dispatch(loginUserAction.loginSlice())
        const response  :any = await loginUserAPI(data)
        
        localStorage.setItem("token",response?.data?.token)
        localStorage.setItem("user",JSON.stringify(response?.data))
        dispatch(loginUserAction.loginSliceSuccess(response))
    } catch (error:any) {
        dispatch(loginUserAction.loginSliceFailure(error?.response?.data))
    }
}
export default loginUserSlice.reducer;
export const loginUserAction = loginUserSlice.actions;